import { shell, Eyebrow, Title, SubTitle, serif } from "../components/CommonComponents";

export default function Outcomes({ course }) {
  return (
    <section id="outcomes" className="relative overflow-hidden bg-[#8B1E3F] py-20 text-white sm:py-24 lg:py-28">
      <img
        src={course.images.studentLife}
        alt="ISBM University student community"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.14]"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#8B1E3F] via-[#8B1E3F]/95 to-[#071A2F]/65" />
      <div className="absolute -right-40 -top-40 h-[500px] w-[500px] rounded-[3px_18px_3px_3px] border border-white/10" />
      <div className={`${shell} relative`}>
        <Eyebrow dark>Graduate capabilities</Eyebrow>
        <Title dark>{course.shortName} Course Outcome</Title>
        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {course.outcomes.map(([title, text], i) => (
            <article
              key={title}
              className="rounded-[6px_24px_6px_6px] border-l-4 border-l-[#D5AD57] border-y border-r border-white/15 bg-[#8B1E3F]/45 p-7 backdrop-blur-sm"
            >
              <span className="text-sm font-bold text-[#D5AD57]">
                OUTCOME 0{i + 1}
              </span>
              <h3 className={`${serif} mt-5 text-3xl`}>{title}</h3>
              <p className="mt-4 text-sm leading-7 text-white/70">{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
